import { TextProps } from "@chakra-ui/react";

export interface PieChartItem {
  name: string;
  value: number;
  color?: string;
}

export const titleProps: TextProps = {
  textTransform: "uppercase",
  fontSize: "xs",
  fontWeight: "semibold",
  textAlign: "center",
  maxW: "240px",
  pt: "24px",
};

const chartSize = 320;
export const pieChartProps = {
  height: chartSize * 0.7,
  width: chartSize,
};
